import { RouterState } from 'mobx-state-router';

const unauthorizedRoute = new RouterState('unauthorized');

export { unauthorizedRoute };
